import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
Wrapper.displayName = 'Wrapper';

export const Label = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.emptyState};
`;
Label.displayName = 'Label';
